import { supabase } from '../config/supabase';
import toast from 'react-hot-toast';
import { getUserFriendlyError } from '../utils/errorHandlers';

/**
 * Family Management Service
 *
 * Handles all operations related to a sponsor's family members.
 */

/**
 * List family members for a given sponsor.
 *
 * @param {Object} params - Parameters.
 * @param {string} params.tenantId - The tenant ID.
 * @param {string} params.sponsorId - The sponsor's user ID.
 * @returns {Promise<{data: Array, error: null}|{data: null, error: Error}>}
 */
export const listFamilyMembers = async ({ tenantId, sponsorId }) => {
  if (!tenantId || !sponsorId) {
    const error = new Error('tenantId and sponsorId are required.');
    toast.error(error.message);
    return { data: null, error };
  }

  try {
    let query = supabase
      .from('sponsorships')
      .select(`
        *,
        patient:users!sponsorships_patient_id_fkey (
          id,
          first_name,
          last_name,
          email,
          status
        )
      `)
      .eq('tenant_id', tenantId)
      .eq('sponsor_id', sponsorId);

    const { data, error } = await query;
    if (error) throw error;

    // The query returns sponsorship records with nested patient objects.
    // We want to return a list of the patient objects themselves.
    const familyMembers = data.map(sponsorship => sponsorship.patient);

    return { data: familyMembers, error: null };
  } catch (error) {
    console.error('Error listing family members:', error);
    const friendlyError = getUserFriendlyError(error);
    toast.error(friendlyError);
    return { data: null, error };
  }
};

export default {
  listFamilyMembers,
};
